import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InsightsSelectQuestionnaireComponent } from './insights-select-questionnaire.component';
import { SearchCoreModule } from 'src/app/components/search-core/search-core.module';
import { FormsModule } from "@angular/forms";
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TooltipEllipsifyModule } from 'src/app/directives/tooltip-ellipsify/tooltip-ellipsify.module';
import { SortV2Module } from 'src/app/components/sort-v2/sort-v2.module';
import { AppPaginationModule } from 'src/app/components/pagination/pagination.module';
import {
  ButtonModule,
  TooltipModule as XrefTooltipModule
} from '@xref/xref-lib';

@NgModule({
  declarations: [InsightsSelectQuestionnaireComponent],
  imports: [
    CommonModule,
    FormsModule,
    BsDropdownModule.forRoot(),
    BrowserAnimationsModule,
    SearchCoreModule,
    PopoverModule.forRoot(),
    TooltipModule.forRoot(),
    TooltipEllipsifyModule,
    SortV2Module,
    AppPaginationModule,
    ButtonModule,
    XrefTooltipModule
  ],
  exports: [InsightsSelectQuestionnaireComponent]
})
export class InsightsSelectQuestionnaireModule { }
